import { testResultSchema } from '../testResultSchema'

// 分類定数・フォーム表示用スキーマのみここに置く。OCR専用のプロンプト・OCR出力スキーマは
// @mbscan/backend-ocr（packages/backend/ocr/src/categories/document/schemas/todaEnkabutsu.ts）が正本。

export const todaEnkabutsuDocumentNameText = '塩化物量測定結果_日東コンクリート'
export const todaEnkabutsuDocumentType = '塩化物量測定結果'
export const todaEnkabutsuInspectionCompanyName = '日東コンクリート'
export const todaEnkabutsuGeneralContractorName = '戸田建設'

// 受入検査結果は塩化物量列のみ抽出するが、フォーム表示は受入検査結果ブロックを丸ごと出して
// 関係ない欄を空のまま放置する運用とする（フォーム側でサブフィールドの足し引きは現状サポートしていない）。
export const todaEnkabutsuFormFieldsSchema = testResultSchema.pick({
  打設日: true,
  打設箇所: true,
  種類: true,
  呼び強度: true,
  スランプ_cm: true,
  骨材寸法_mm: true,
  セメント: true,
  プラント名: true,
  受入検査結果: true,
  使用測定器: true,
})
